import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import * as types from "constants/actionTypes";
import { FormControl, FormHelperText } from "@mui/material";

class SelectInput extends Component {
    componentDidMount() {
        const { value, defaultValue, options, name, dispatch } = this.props;
        if (!value && defaultValue) {
            const selectedItem = options.find((item) => item.value === defaultValue);
            dispatch({ type: types.FORM_INPUT, value: defaultValue, name });

            if (selectedItem) {
                dispatch({ type: types.FORM_INPUT, value: selectedItem.text, name: `${name}Text` });
            }
        }
    }

    onChange = (event) => {
        const selectedValue = event.target.value;
        const { options, name, dispatch, onChange } = this.props;

        const selectedItem = options.find((item) => item.value === selectedValue);
        dispatch({ type: types.FORM_INPUT, value: selectedValue, name });

        if (selectedItem) {
            dispatch({ type: types.FORM_INPUT, value: selectedItem.text, name: `${name}Text` });
        }

        if (onChange) {
            onChange(selectedValue);
        }
    };

    render() {
        const { options, className, errorText, errorStyle, fullWidth, value, name, ...otherProps } = this.props;

        if (!options) return null;

        return (
            <FormControl
                fullWidth={fullWidth}
                error={!!errorText}
                style={{ marginBottom: "16px" }}
            >
                <Select
                    name={name}
                    value={value || ""}
                    onChange={this.onChange}
                    displayEmpty
                    {...otherProps}
                >
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
                {errorText && (
                    <FormHelperText style={errorStyle || { color: "red" }}>
                        {errorText}
                    </FormHelperText>
                )}
            </FormControl>
        );
    }
}

const mapStateToProps = (state, props) => ({
    value: state.form[props.name],
    error: state.form && state.form.error && state.form.error[props.name],
});

export default connect(mapStateToProps)(SelectInput);
